const MESSAGE_EVENTS = new Set(['CHAT_QUERY', 'CHAT_RESPONSE'])

// Every point in a replay where something the student worked on changed: the code, the
// written explanation, or a new chat message. Events at the same instant form one step, and
// each step keeps what came before it, so the replay can highlight just that step's change:
// codeBefore / explanationBefore (null when that field didn't change) and the chat messages
// it added (messagesBefore + 1 .. messagesBefore + newMessages, matching useReplayState's
// message ids). `time` is the real clock time (wallTime when the timeline was compressed).
export function changeSteps (events, starterCode = '') {
  const steps = []
  let code = starterCode
  let explanation = ''
  let messages = 0
  for (const e of events) {
    const nextCode = e.payload?.code
    const nextExplanation = e.payload?.explanation
    const codeChanged = nextCode !== undefined && nextCode !== code
    const explanationChanged = typeof nextExplanation === 'string' && nextExplanation !== explanation
    const isMessage = MESSAGE_EVENTS.has(e.type)
    if (codeChanged || explanationChanged || isMessage) {
      let step = steps[steps.length - 1]
      if (!step || step.timestamp !== e.timestamp) {
        step = { timestamp: e.timestamp, time: e.wallTime ?? e.timestamp, codeBefore: null, explanationBefore: null, messagesBefore: messages, newMessages: 0 }
        steps.push(step)
      }
      if (codeChanged && step.codeBefore === null) step.codeBefore = code
      if (explanationChanged && step.explanationBefore === null) step.explanationBefore = explanation
      if (isMessage) step.newMessages++
    }
    if (nextCode !== undefined) code = nextCode
    if (typeof nextExplanation === 'string') explanation = nextExplanation
    if (isMessage) messages++
  }
  return steps
}
